module.exports = __webpack_public_path__ + "img/facebook_login.cdbce77d.png";